import { useSabaCoinEvent } from '@/contexts/saba-coin-context';

export const useCoinThresholds = () => {
	const { sabaCoinEventInfo } = useSabaCoinEvent();

	const achievedThreshold = [...sabaCoinEventInfo.Thresholds]
		.reverse()
		.find(threshold => 
			threshold.ThresholdAmount <= sabaCoinEventInfo.WeeklyBettingAmount
		);

	return {
		thresholds: sabaCoinEventInfo.Thresholds,
		achievedThreshold,
		totalThresholdAmount: sabaCoinEventInfo.Thresholds.length,
	};
};